import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  requireContract: Yup.boolean(),
  contract: Yup.number()
    .nullable()
    .when('requireContract', {
      is: true,
      then: Yup.number()
        .required('El campo es requerido')
        .min(1, 'Ingresa un contrato válido.')
    }),
  cosignerDoctype: Yup.string().required('El campo es requerido'),
  cosignerDocid: Yup.string()
    .when('cosignerDoctype', {
      is: 'Cédula',
      then: Yup.string()
        .matches(
          /^[0-9]+$/,
          'Tipo de documento no admite caracteres especiales o letras.'
        )
        .required('El campo es requerido')
    })
    .when('cosignerDoctype', {
      is: 'Pasaporte',
      then: Yup.string()
        .matches(
          /^[A-Z-a-z-0-9-]+$/,
          'Tipo de documento no admite caracteres especiales.'
        )
        .required('El campo es requerido')
    })
    .when('cosignerDoctype', {
      is: 'Cédula de Extranjería',
      then: Yup.string()
        .matches(
          /^[A-Z-a-z-0-9-]+$/,
          'Tipo de documento no admite caracteres especiales.'
        )
        .required('El campo es requerido')
    })
    .when('cosignerDoctype', {
      is: 'Nit / Rut',
      then: Yup.string()
        .matches(
          /^[0-9-]+$/,
          'Tipo de documento solo admite números y el caracter - '
        )
        .required('El campo es requerido')
    }),
  birthday: Yup.string()
    .required('El campo es requerido')
    .nullable()
});
